// src/com/tsr/TsrMain.js
import React, {useEffect, useState} from 'react';
import { TsrPageStyle } from './TsrStyle';
import TsrPrintExpress from './TsrPrintExpress';
import TsrPrintAdc from './TsrPrintAdc';
import TsrPrintFresh from './TsrPrintFresh';
import { useLazyQuery } from '@apollo/client';
import { CircularProgress } from '@mui/material';
import { useAlertSetter } from '../../api/app-hook';
import { GET_TRANS_PLAN_TSR } from '../tsr/TransPlanTsrGql';
import { AppObject, TopCode } from '../../value/AppConst';
import ValueMisc from '../../value/ValueMisc';

/**
 * App.js에서 호출하는 세가지 메인 컴포넌트 중 하나로
 * URL에서 planId를 받아서 해당 TSR을 조회하고 출력하는 컴포넌트
 * @returns 
 */
export default function TsrMain({
    urlPassed=null
}) {
    const [tsrData, setTsrData] = useState(null);
    const [message, setMessage] = useState(null);
    const addAlert = useAlertSetter();
    const [getTransPlanTsrItem, responseItem] = useLazyQuery(GET_TRANS_PLAN_TSR, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetTransPlanTsrItem(data, option)},
        onError: (error) => addAlert({title: '배차정보 조회 오류', message: [error.message]})
    });

    useEffect(() => {
        document.body.style = import('../../asset/css/NT_TrailerSeal.css');
        const paramPassed = ValueMisc.getUrlJsonParam(urlPassed); // from jx=[url encoded json]
        if(paramPassed.planId) {
            setMessage("배차정보 조회 중입니다.");
            getTransPlanTsrItem({variables: {planId: paramPassed.planId}});
        }
        else {
            setMessage("조회할 배차정보를 지정하지 않았습니다.")
        }
    }, []);

    const onCompleteGetTransPlanTsrItem = (data, option) => {
        if(data.transPlanTsrItem) {
            setTsrData(data.transPlanTsrItem);
        }
        else {
            setMessage("배차정보를 조회할 수 없습니다.");
            addAlert({title:'배차정보 조회 오류', message:['배차정보를 찾을 수 없습니다.']});
        }
    };


    const renderMessage = (msg) => {
        return (
            <div size="A4" style={TsrPageStyle}>
                <div style={{color: '#f50', marginTop: '50mm', textAlign: 'center'}}>
                    <h1 style={{fontSize: '3rem'}}>TRAILER SEAL RECORD</h1>
                    {
                        responseItem.loading &&
                        <CircularProgress size={32} />
                    }
                    <h4 style={{fontSize: '1.5rem'}}>{msg || message || "잠시 기다려 주세요"}</h4>
                </div>
            </div>
        );
    };

    if(tsrData) {
        if(tsrData.dcTypeCd===TopCode.DcTypeCode.Express)
            return <TsrPrintExpress tsrData={tsrData} />
        if(tsrData.dcTypeCd===TopCode.DcTypeCode.General)
            return <TsrPrintAdc tsrData={tsrData} />
        if(tsrData.dcTypeCd===TopCode.DcTypeCode.Fresh)
            return <TsrPrintFresh tsrData={tsrData} />
        return renderMessage("알 수 없는 센터유형입니다: " + tsrData.dcTypeCd);
    }

    return renderMessage();
}